import { PluginSidebar } from '@wordpress/edit-site';
import BlockbiteSidebar from './sideBar.js';

const BlockbiteSiteSidebar = () => {
  return (
    <PluginSidebar name="plugin-sidebar-blockbite" title="Blockbite">
      <BlockbiteSidebar />
    </PluginSidebar>
  );
};

export default BlockbiteSiteSidebar;
